/**
 * 後台權限樹工具：由扁平權限列表建樹、葉節點勾選與父子聯動。
 */

/** 從扁平列表找出葉節點 ID（與後端 findLeafNodeIds 一致） */
export function findLeafNodeIds(permissions) {
  if (!permissions?.length) {
    return [];
  }
  const parentIds = new Set(
    permissions
      .map((item) => item.parentId)
      .filter((parentId) => parentId != null && parentId !== 0)
  );
  return permissions
    .map((item) => item.id)
    .filter((id) => !parentIds.has(id));
}

/** 將扁平權限列表建為樹 */
export function buildPermissionTree(permissions, parentId = 0) {
  if (!permissions?.length) {
    return [];
  }
  return permissions
    .filter((item) => (item.parentId ?? 0) === parentId)
    .sort((a, b) => {
      const sortDiff = (a.sort ?? 0) - (b.sort ?? 0);
      if (sortDiff !== 0) {
        return sortDiff;
      }
      return (a.id ?? 0) - (b.id ?? 0);
    })
    .map((item) => ({
      ...item,
      children: buildPermissionTree(permissions, item.id),
    }));
}

/** 計算節點勾選狀態 */
export function getNodeCheckState(node, checkedLeafIds) {
  const leafIds = getLeafIdsUnderNode(node);
  const checkedCount = leafIds.filter((id) => checkedLeafIds.has(id)).length;
  if (checkedCount === 0) {
    return 'unchecked';
  }
  if (checkedCount === leafIds.length) {
    return 'checked';
  }
  return 'indeterminate';
}

function getLeafIdsUnderNode(node) {
  if (!node.children?.length) {
    return [node.id];
  }
  return node.children.flatMap((child) => getLeafIdsUnderNode(child));
}

/** 切換節點勾選（以葉節點 ID 為準） */
export function toggleNodeCheck(node, checkedLeafIds, nextChecked) {
  const next = new Set(checkedLeafIds);
  const leafIds = getLeafIdsUnderNode(node);
  leafIds.forEach((id) => {
    if (nextChecked) {
      next.add(id);
    } else {
      next.delete(id);
    }
  });
  return next;
}

/** 全選 / 全不選 */
export function selectAllLeafIds(allLeafIds) {
  return new Set(allLeafIds);
}

export function clearAllLeafIds() {
  return new Set();
}
